const staffConstants = {
  UPDATE_USER_INFO_REQUEST: "STAFF_UPDATE_USER_INFO_REQUEST",
  UPDATE_USER_INFO_SUCCESS: "STAFF_UPDATE_USER_INFO_SUCCESS",
  UPDATE_USER_INFO_FAILURE: "STAFF_UPDATE_USER_INFO_FAILURE",

  UPDATE_ATTORNEY_INFO_REQUEST: "STAFF_UPDATE_ATTORNEY_INFO_REQUEST",
  UPDATE_ATTORNEY_INFO_SUCCESS: "STAFF_UPDATE_ATTORNEY_INFO_SUCCESS",
  UPDATE_ATTORNEY_INFO_FAILURE: "STAFF_UPDATE_ATTORNEY_INFO_FAILURE",

  PASSWORD_RESET_REQUEST: "STAFF_PASSWORD_RESET_REQUEST",
  PASSWORD_RESET_SUCCESS: "STAFF_PASSWORD_RESET_SUCCESS",
  PASSWORD_RESET_FAILURE: "STAFF_PASSWORD_RESET_FAILURE",

  REGISTER_REQUEST: "STAFF_REGISTER_REQUEST",
  REGISTER_SUCCESS: "STAFF_REGISTER_SUCCESS",
  REGISTER_FAILURE: "STAFF_REGISTER_FAILURE",

  REGISTER_ATTORNEY_REQUEST: "STAFF_REGISTER_ATTORNEY_REQUEST",
  REGISTER_ATTORNEY_SUCCESS: "STAFF_REGISTER_ATTORNEY_SUCCESS",
  REGISTER_ATTORNEY_FAILURE: "STAFF_REGISTER_ATTORNEY_FAILURE",
  // GETALL_REQUEST: "USERS_GETALL_REQUEST",
  // GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  // GETALL_FAILURE: "USERS_GETALL_FAILURE"
};

export default staffConstants;
